import { Component, inject } from '@angular/core';
import dayjs from 'dayjs';
import { RequestStateEnum } from '../../../enums/app.enum';
import { ActivityStore } from '../../../stores/activity.store';
import { CardHeaderComponent } from '../../atoms/card-header/card-header.component';
import { CardComponent } from '../../atoms/card/card/card.component';
import { NoEntriesPlaceholderComponent } from '../../molecules/no-entries-placeholder/no-entries-placeholder.component';
import { PaginatorComponent } from '../../molecules/paginator/paginator.component';
import { PaginatorIntervalTypeEnum } from '../../molecules/paginator/paginator.enum';
import { ActivityItemComponent } from './activity-item/activity-item.component';

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  imports: [
    CardComponent,
    CardHeaderComponent,
    NoEntriesPlaceholderComponent,
    ActivityItemComponent,
    PaginatorComponent,
  ],
})
export class ActivitiesComponent {
  private readonly activityStore = inject(ActivityStore);

  protected readonly RequestStateEnum = RequestStateEnum;
  protected readonly paginatorIntervalTypeEnum = PaginatorIntervalTypeEnum;

  public activities = this.activityStore.entities;
  public requestState = this.activityStore.requestState;

  public onPaginatorChange(index: number, year: number): void {
    const start = dayjs().year(year).isoWeek(index).startOf('week');
    const end = dayjs().year(year).isoWeek(index).endOf('week');

    this.activityStore.loadInRange(start, end, 10, 0);
  }
}
